import { APPSUMO_PLAN_IDS, PlanIds } from '@/constants/plan';

const isAppsumoUser = (planId: number): boolean =>
  APPSUMO_PLAN_IDS.includes(planId as PlanIds);

export default isAppsumoUser;
